export class PerimeterAreaConstants {
}
PerimeterAreaConstants.defaultPerimeter = 7.00;
PerimeterAreaConstants.defaultArea = 10.00;
